const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the group list search directive
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('chipContentSearch', ['Application', 'Videos', 'Files', 'Articles', 'Tracks', 'ScormContent', 'ImportedContent', 'Assessments', 'Workshops', 'Surveys', 'Journeys', '$q', function (Application, Videos, Files, Articles, Tracks, ScormContent, ImportedContent, Assessments, Workshops, Surveys, Journeys, $q) {
  return {
    restrict: 'E',
    scope: {
      originalContent: '=',
      onChange: '&',
      selected: '=',
      omittedContentTypes: '=',
      context: '=',
      showResult: '&',
      initialIdsByType: '<',
      disableCriteria: '<',
      placeholderCopyKey: '<',
      availabilityInDays: '=?'
    },
    template: require('../../templates/directives/chip-content-search.html'),
    controller: ['$scope', function ($scope) {
      // omittedContentTypes must be passed in as a list
      var self = this;
      self.creator = Application.access.user;
      self.doNotIncludeInSearch = $scope.originalContent || [];
      self.omittedContentTypes = $scope.omittedContentTypes || [];
      self.initialIdsByType = $scope.initialIdsByType || [];


      const checkForAssessments = function() {
        return $scope.selected.some(item => item.type === 'assessment');
      }


      self.content = {
        loading: false,
        term: '',
        options: [],
        remove: function(content) {
          if ($scope.availabilityInDays) {
            $scope.availabilityInDays = 0;
            self.journeys.days = "";
            self.journeys.availability = 'immediate';
          }
          for (let i = $scope.selected.length - 1; i >= 0; i--) {
            if (content._id === $scope.selected[i]._id) {
              $scope.selected.splice(i, 1)
              self.assessmentSelected = checkForAssessments();
              break;
            }
          }
          if ($scope.originalContent?.length > 0) {
            for (const [i, id] of $scope.originalContent.entries()) {
              if (content._id === id) {
                $scope.originalContent.splice(i, 1);
                return;
              }
            }
          }
        },
        addTag: function(content) {
          $scope.selected.push(content);
          self.doNotIncludeInSearch.push(content._id);
          self.assessmentSelected = checkForAssessments();
          self.content.term = '';
        }
      };

      self.journeys = {
        availability: 'immediate',
        days: ""
      };
      self.journeyEvents = {
        onChange: function(availability) {
          if (availability === 'immediate') {
            self.journeys.days = "";
            $scope.availabilityInDays = 0;
          }
        },
        onDaysChange: function() {
          self.journeys.availability = 'blocked';
          $scope.availabilityInDays = self.journeys.days;
        },
      };


      self.placeholders = {
        all: {name: 'All', _id: 'all'},
        article: {name: 'Articles', text: 'Articles', _id: 'articles', type: 'article', placeholder: true},
        video: {name: 'Videos', text: 'Videos', _id: 'videos', type: 'video', placeholder: true},
        file: {name: 'Files', text: 'Files', _id: 'files', type: 'file', placeholder: true},
        track: {name: 'Tracks', text: 'Tracks', _id: 'tracks', type: 'track',placeholder: true},
        scorm: {name: 'Scorm', text: 'Scorm', _id: 'scorm', type: 'scorm', placeholder: true},
        imported_content: {name: 'ImportedContent', text: 'Imported Content', _id: 'imported_content', type: 'imported_content',placeholder: true},
        assessment: {name: 'Assessment', text: 'Assessment', _id: 'assessment', type: 'article', placeholder: true},
        workshop: {name: 'Workshop', text: 'Workshop', _id: 'workshop', type: 'workshop', placeholder: true},
        survey: {name: 'Survey', text: 'Surveys', _id: 'survey', type: 'survey', placeholder: true},
        journey: {name: 'Journey', text: 'Journeys', _id: 'journey', type: 'journey', placeholder: true},
      };

      if (Application.features.journeys()) {
        self.placeholders.journey = {name: 'Journey', text: 'Journeys', _id: 'journey', type: 'journey', placeholder: true};
      }

      self.typeMap = {
        'article': Articles,
        'video': Videos,
        'file': Files,
        'track': Tracks,
        'scorm': ScormContent,
        'imported_content': ImportedContent,
        'assessment': Assessments,
        'workshop': Workshops,
        'survey': Surveys,
        'journey': Journeys,
      };

      self.initialValueFormatByType = async function() {
        const {initialIdsByType} = $scope;
        let promises = [];
        for (const key in initialIdsByType) {
          if (!initialIdsByType[key].length) {
            continue;
          }
          if (key === 'survey') {
            // update this if we support multiple surveys
            promises.push(Surveys.get({subresource: initialIdsByType[key][0].survey_id}).$promise);
            continue;
          } 
          const contentQuery = {
            _id: `$in,${initialIdsByType[key].length},${initialIdsByType[key].join(',')}`,
            fields: `type,${key === 'track' ? 'name' : 'title'}`,
          };
          const journeyQuery = {query: {_id: initialIdsByType[key]}};
          const query = key === 'journey' ? journeyQuery : contentQuery;
          if (key === 'media') {
            promises = promises.concat([Videos.find(query).$promise, Files.find(query).$promise]);
          } else {
            promises.push(self.typeMap[key].find(query).$promise);
          }
        }

        let items = await Promise.all(promises);
        items = items.flat();
        $scope.selected = items.map(content => ({
          text: content.title,
          name: content.title,
          _id: content._id,
          type: content.type || 'survey',
        }));
        $scope.$apply();
      }

      $scope.$watch('chipSearch.content.term', async function(newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }
        if (!newVal || newVal.length < 3) {
          self.content.options.splice(0);
          return;
        }

        const typesWithReturnedContent = {
          articles: false,
          videos: false,
          files: false,
          tracks: false,
          scorm: false,
          imported_content: false,
          assessment: false,
          workshop: false,
          survey: false,
          journey: false,
        }; 

        const contentQuery = {
          subresource: '',
          page: 1,
          per_page: 10,
          fields: 'title,tags,type,surveys',
          $or: '10,title,$regex,2,' + self.content.term + ',i,tags,$regex,2,' + self.content.term + ',i' 
        };
        const trackQuery = {
          subresource: '',
          page: 1,
          per_page: 10,
          fields: 'name,tags,surveys',
          $or: '10,name,$regex,2,' + self.content.term + ',i,tags,$regex,2,' + self.content.term + ',i'
        };
        const surveyAndJourneyQuery = {
          subresource: '',
          page: 0,
          perPage: 10,
          query: {term: self.content.term}
        };

        const notIncludedInSearch = self.doNotIncludeInSearch && self.doNotIncludeInSearch.length && `$nin,${self.doNotIncludeInSearch.length},${self.doNotIncludeInSearch.join(',')}` || '';
        if (notIncludedInSearch && notIncludedInSearch.length) {
          contentQuery._id = notIncludedInSearch;
          trackQuery._id = notIncludedInSearch;
          // add survey logic here if we allow attaching multiple to content
        }

        // Handle the omitting of certain workshop types
        const workshopOptions = {};
        const omittedWorkshopTypes = self.omittedContentTypes.filter(type => {
          if (type === 'multi_session_workshop' || type === 'multi_session_workshop_session') {
            return true;
          }
          return false;
        })
        if (omittedWorkshopTypes.length) {
          workshopOptions.omitted_workshop_types = omittedWorkshopTypes;
        }


        const articlePromise = !self.omittedContentTypes.includes('article') && Articles.find(contentQuery).$promise;
        const videoPromise = !self.omittedContentTypes.includes('video') && Videos.find(contentQuery).$promise;
        const filePromise = !self.omittedContentTypes.includes('file') && Files.find(contentQuery).$promise;
        const trackPromise = !self.omittedContentTypes.includes('track') && Tracks.find(trackQuery).$promise;
        const scormPromise = !self.omittedContentTypes.includes('scorm') && ScormContent.find(contentQuery).$promise;
        const importedContentPromise = !self.omittedContentTypes.includes('imported_content') && ImportedContent.find(contentQuery).$promise;
        const assessmentPromise = !self.omittedContentTypes.includes('assessment') && Assessments.find(contentQuery).$promise;
        const workshopsPromise = !self.omittedContentTypes.includes('workshop') && Workshops.find({...workshopOptions, ...contentQuery}).$promise;
        const surveysPromise = !self.omittedContentTypes.includes('survey') && Surveys.list(surveyAndJourneyQuery).$promise;
        const contentPromises = [articlePromise, videoPromise, filePromise, trackPromise, scormPromise, importedContentPromise, assessmentPromise, workshopsPromise, surveysPromise];
        if (Application.features.journeys() && !self.omittedContentTypes.includes('journey')) {
          const journeysPromise = Journeys.find(surveyAndJourneyQuery).$promise;
          contentPromises.push(journeysPromise);
        }

        $q.all(contentPromises).then(function (results) {
          var directory = {
            0: 'article',
            1: 'video',
            2: 'file',
            3: 'track',
            4: 'scorm',
            5: 'imported_content',
            6: 'assessment',
            7: 'workshop',
            8: 'survey',
            9: 'journey',
          };

          var items = [];
          for (var i = 0; i < results.length; i++) {
            if (!results[i] || !results[i].length) {
              continue;
            }
            var type = directory[i];
            if (!typesWithReturnedContent[type]) {
              items.push(self.placeholders[type]);
              typesWithReturnedContent[type] = true;
            }
            for (var j = 0; j < results[i].length; j++) {
              // don't show result if upper scope function returns false, but show result if function doesn't exist
              if (!$scope.showResult({item: results[i][j]}) && $scope.showResult({item: results[i][j]}) !== undefined) {
                continue;
              }
              items.push({
                name: results[i][j].title || results[i][j].name,
                text: results[i][j].title || results[i][j].name,
                _id: results[i][j]._id,
                type: type
              });
            }
          }
          self.content.options = items;
        });
      });

      $scope.$watch('chipSearch.initialIdsByType', async function(newVal, oldVal) {
        // no need to compare values, this will only be set once
        // comparing can make issues with directives' ng-if and ng-show logic
        if (!newVal) {
          return;
        }
        await self.initialValueFormatByType();
      }, true);

    }],
    controllerAs: 'chipSearch'
  };
}]);